import _get from 'lodash/get';
import {
  TableFilterConditionsConnection,
  TableFilterEqualityOperator,
  TableRangeOperator,
} from '../filterTableTool.enums';
import {BetweenRangeFilterCondition, SingleValueFilterCondition} from '../filterTableTool.types';

function filterTableData<T>(
  data: T[],
  conditions: (SingleValueFilterCondition | BetweenRangeFilterCondition)[],
  conditionsConnection: TableFilterConditionsConnection,
): T[] {
  if (!conditions.length) return data;

  function _convertToComparableString(value: unknown): string {
    return typeof value === 'object' && value !== null ? JSON.stringify(value) : String(value);
  }

  function _applyFilter(
    row: T,
    condition: SingleValueFilterCondition | BetweenRangeFilterCondition,
  ) {
    const cellValue = _get(row, condition.property);

    switch (condition.operator) {
      case TableFilterEqualityOperator.Equal:
        return (
          _convertToComparableString(cellValue) === _convertToComparableString(condition.value)
        );

      case TableFilterEqualityOperator.NotEqual:
        return (
          _convertToComparableString(cellValue) !== _convertToComparableString(condition.value)
        );

      case TableFilterEqualityOperator.Contains:
        if (typeof cellValue === 'string' && typeof condition.value === 'string') {
          return cellValue.toLowerCase().includes(condition.value.toLowerCase());
        }

        if (Array.isArray(cellValue)) {
          return cellValue.some((item) => {
            if (typeof item === 'string') {
              return item.toLowerCase().includes((condition.value as string).toLowerCase());
            }

            return cellValue.includes(condition.value);
          });
        }

        return false;

      case TableFilterEqualityOperator.NotContains:
        if (typeof cellValue === 'string' && typeof condition.value === 'string') {
          return !cellValue.toLowerCase().includes(condition.value.toLowerCase());
        }

        if (Array.isArray(cellValue)) {
          return cellValue.every((item) => {
            if (typeof item === 'string') {
              return !item.toLowerCase().includes((condition.value as string).toLowerCase());
            }

            return !cellValue.includes(condition.value);
          });
        }

        return true;

      case TableRangeOperator.BetweenRange:
        if (condition.minValue && condition.maxValue) {
          return cellValue >= condition.minValue && cellValue <= condition.maxValue;
        }

        return false;

      case TableFilterEqualityOperator.LargerThan:
        return cellValue > condition.value;

      case TableFilterEqualityOperator.LowerThan:
        return cellValue < condition.value;

      default:
        return true;
    }
  }

  return data.filter((row) => {
    return conditionsConnection === TableFilterConditionsConnection.And
      ? conditions.every((condition) => _applyFilter(row, condition))
      : conditions.some((condition) => _applyFilter(row, condition));
  });
}

export default filterTableData;
